import css from 'styled-jsx/css';

const styles = css`
  .switch {
    position: relative;
    display: inline-block;
    &.toggle-switch {
      display: inline;
    }
  }

  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #bbb;
    -webkit-transition: 0.4s;
    transition: 0.4s;
    width: 43.2px;
    height: 15.6px;
  }

  .slider::before {
    position: absolute;
    content: '';
    height: 24px;
    width: 24px;
    left: -1px;
    bottom: -4px;
    background-color: #f8f8f8;
    -webkit-transition: 0.4s;
    transition: 0.4s;
    border-width: 1px;
    border-style: solid;
    border-color: #cacaca;
    box-shadow: -1px 2px 4px rgba(129, 124, 124, 0.25);
  }

  input:checked + .slider::before {
    -webkit-transform: translateX(23px);
    -ms-transform: translateX(23px);
    transform: translateX(23px);
    background-color: var(--primary-color);
    border: 1px solid var(--primary-color);
  }

  input:checked + .slider.tottus::before {
    background-color: var(--teal-shade1);
    border: 1px solid var(--teal-shade1);
  }

  .slider.round {
    border-radius: 34px;
    &.toggle-switch {
      height: 24px;
      transition: 0.4s, background 0s !important;
      &.is-selected {
        background: var(--primary-color) !important;
      }
    }
  }

  .slider.round::before {
    border-radius: 50%;
  }
  .slider.round.toggle-switch::before {
    height: 24px;
    background: #f9f9f9 !important;
    bottom: unset;
    transition: 0.4s, border 0s !important;
  }
  .slider.round.toggle-switch.is-selected::before {
    border: 1px solid var(--primary-color) !important;
  }
`;

export { styles };
